var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('ul', { directives: [{ name: "show", rawName: "v-show", value: _vm.visible, expression: "visible" }], staticClass: "el-select-group__wrap" }, [_c('li', { staticClass: "el-select-group__title" }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('li', [_c('ul', { staticClass: "el-select-group" }, [_vm._t("default")], 2)])]);
};
var staticRenderFns = [];

export { render, staticRenderFns };